module.exports = __webpack_public_path__ + "media/images/amenities_icons/bean-bag-d35d82ebc32da64b419ab8b7f093c359.svg";